export default __webpack_public_path__ + "static/media/cross-icon.ba9a30b8.svg";